define('home/views/UserActiveForumsModuleView',[
    'backbone-marionette',

    'home/views/FollowingCardView',

    'home/templates/profileModuleActiveForums',
], function (
    Marionette,

    FollowingCardView,

    profileModuleActiveForumsTemplate
) {
    'use strict';

    var UserActiveForumsModuleView = Marionette.CompositeView.extend({
        template: profileModuleActiveForumsTemplate,

        itemView: FollowingCardView,
        itemViewContainer: '[data-role=forums]',
    });

    return UserActiveForumsModuleView;
});

